import { useState } from "react";
import { connect } from "react-redux";

import HistoryIcon from "@mui/icons-material/DateRange";
import LineGraphIcon from "@mui/icons-material/ShowChart";
import RegressionIcon from "@mui/icons-material/Shuffle";
import { Grid, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import { getDateRangeCaption } from "../../utils/helpers";
import SingleSymptomGraph from "../graphing/singleSymptomGraph";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogTitle from "../ui/omniDialogTitle";
import OmniGraphFab from "../ui/omniGraphFab";

const SingleSymptomDialog = props => {
  const { open, singleSymptomData, dialogTitle = "Symptom History" } = props;

  const [graphTimeRange, setGraphTimeRange] = useState(constants.graphTimeRange.long);

  const [graphStyle, setGraphStyle] = useState(constants.graphTypes.regressionGraph);

  const onCloseHandler = () => {
    props.onClose();
  };

  const GetDisplayDescription = () => {
    if (graphStyle === constants.graphTypes.controlLimitGraph) {
      return `Control Chart`;
    } else {
      return `Regression Analysis`;
    }
  };

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onCloseHandler}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth={true}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Grid
          container
          justifyContent="space-between"
          direction="row"
          sx={{
            marginBottom: theme.spacing(1),
          }}
        >
          {/* Title */}
          <Grid container item xs={12} md={6} alignItems="baseline">
            <Grid item>
              <Typography
                variant="h6"
                sx={{ fontSize: "x-large", whiteSpace: "pre", marginLeft: theme.spacing(4) }}
              >
                {GetDisplayDescription()}
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                variant="caption"
                sx={{ marginLeft: theme.spacing(1), marginTop: theme.spacing(1.75) }}
              >
                {getDateRangeCaption(singleSymptomData.graphLabels, graphTimeRange)}
              </Typography>
            </Grid>
          </Grid>
          {/* FABS */}
          <Grid container item xs={12} md={6} justifyContent="flex-end">
            {/* All */}
            <OmniGraphFab
              tooltipTitle="All History"
              selected={graphTimeRange === constants.graphTimeRange.long}
              onClick={e => {
                e.stopPropagation();
                setGraphTimeRange(constants.graphTimeRange.long);
              }}
            >
              <HistoryIcon />
            </OmniGraphFab>
            {/* 6 Months */}
            <OmniGraphFab
              tooltipTitle="Last 6 Months"
              selected={graphTimeRange === constants.graphTimeRange.medium}
              onClick={e => {
                e.stopPropagation();
                setGraphTimeRange(constants.graphTimeRange.medium);
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                6
              </Typography>
            </OmniGraphFab>
            {/* 3 Months */}
            <OmniGraphFab
              tooltipTitle="Last 3 Months"
              selected={graphTimeRange === constants.graphTimeRange.short}
              onClick={e => {
                e.stopPropagation();
                setGraphTimeRange(constants.graphTimeRange.short);
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                3
              </Typography>
            </OmniGraphFab>
            <Divider
              sx={{
                marginTop: "3px",
                width: "4px",
                backgroundColor: theme.palette.secondary.main,
                marginLeft: "12px",
                marginRight: "4px",
                height: "38px",
                boxShadow: theme.shadows[3],
              }}
            />
            {/* Control Limit Graph */}
            <OmniGraphFab
              tooltipTitle="Control Limits"
              selected={graphStyle === constants.graphTypes.controlLimitGraph}
              onClick={e => {
                e.stopPropagation();
                setGraphStyle(constants.graphTypes.controlLimitGraph);
              }}
            >
              <LineGraphIcon />
            </OmniGraphFab>
            <OmniGraphFab
              tooltipTitle="Regression"
              selected={graphStyle === constants.graphTypes.regressionGraph}
              onClick={e => {
                e.stopPropagation();
                setGraphStyle(constants.graphTypes.regressionGraph);
              }}
            >
              <RegressionIcon />
            </OmniGraphFab>
          </Grid>
        </Grid>
        <SingleSymptomGraph
          sx={{
            marginLeft: theme.spacing(2),
            margingRight: theme.spacing(2),
          }}
          graphTitle={singleSymptomData.graphTitle}
          rawGraphData={singleSymptomData.graphDataComplete}
          graphLabels={singleSymptomData.graphLabels}
          graphIndex={singleSymptomData.graphIndex}
          graphTimeRange={graphTimeRange}
          graphStyle={graphStyle}
          averageSeverity={singleSymptomData.averageSeverity}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={e => onCloseHandler()} color="secondary" variant={"contained"}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SingleSymptomDialog);
